import React from 'react';
import { Breadcrumbs } from 'js/components/Breadcrumbs/Breadcrumbs';
import styles from './Header.module.css';

interface Props {
  bookCta: {
    label: string;
    uri: string;
  };
  breadcrumbs: {
    name: string;
    uri: string;
  }[];
  venueAddress: string;
  venueReviewsTitle: string;
}

export function Header(props: Props): React.ReactElement {
  const { breadcrumbs, venueReviewsTitle, venueAddress, bookCta } = props;
  return (
    <div className={styles.container}>
      <header className={styles.pageWidthWrapper}>
        <Breadcrumbs breadcrumbsParams={breadcrumbs} lastElementLink />
        <h1 className={styles.venueName}>{venueReviewsTitle}</h1>
        <p className={styles.venueAddress}>{venueAddress}</p>
        <a href={bookCta.uri} className={styles.bookCta}>
          {bookCta.label}
        </a>
      </header>
    </div>
  );
}
